// extracted by mini-css-extract-plugin
export default {"cls1":"RXNQHTTR6y9M9mmEtT9D","cls2":"VGQgagxl8szFwzGi35nA RXNQHTTR6y9M9mmEtT9D"};